// extracted by mini-css-extract-plugin
module.exports = {"mobileWidth":"850px","figure":"insetRight-module__figure___5S7eh","caption":"insetRight-module__caption___2UQFV"};